var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuLanguageActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 5.1999C3.2825 5.1999 4 4.4824 4 3.5999C4 2.7174 3.2825 1.9999 2.4 1.9999C1.5175 1.9999 0.8 2.7174 0.8 3.5999C0.8 4.4824 1.5175 5.1999 2.4 5.1999ZM13.6 5.1999C14.4825 5.1999 15.2 4.4824 15.2 3.5999C15.2 2.7174 14.4825 1.9999 13.6 1.9999C12.7175 1.9999 12 2.7174 12 3.5999C12 4.4824 12.7175 5.1999 13.6 5.1999ZM14.4 5.9999H12.8C12.36 5.9999 11.9625 6.1774 11.6725 6.4649C12.68 7.0174 13.395 8.0149 13.55 9.1999H15.2C15.6425 9.1999 16 8.8424 16 8.3999V7.5999C16 6.7174 15.2825 5.9999 14.4 5.9999ZM8 5.9999C9.5475 5.9999 10.8 4.7474 10.8 3.1999C10.8 1.6524 9.5475 0.399902 8 0.399902C6.4525 0.399902 5.2 1.6524 5.2 3.1999C5.2 4.7474 6.4525 5.9999 8 5.9999ZM9.92 6.7999H9.7125C9.1925 7.0499 8.615 7.1999 8 7.1999C7.385 7.1999 6.81 7.0499 6.2875 6.7999H6.08C4.49 6.7999 3.2 8.0899 3.2 9.6799V10.3999C3.2 11.0624 3.7375 11.5999 4.4 11.5999H11.6C12.2625 11.5999 12.8 11.0624 12.8 10.3999V9.6799C12.8 8.0899 11.51 6.7999 9.92 6.7999ZM4.3275 6.4649C4.0375 6.1774 3.64 5.9999 3.2 5.9999H1.6C0.7175 5.9999 0 6.7174 0 7.5999V8.3999C0 8.8424 0.3575 9.1999 0.8 9.1999H2.4475C2.605 8.0149 3.32 7.0174 4.3275 6.4649Z",
    fill: "#DDE2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLanguageActive);
export default __webpack_public_path__ + "static/media/menu-language-active.4eb635b0221704401f2aaa3154c9ac51.svg";
export { ForwardRef as ReactComponent };